// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Belt_Array = require("rescript/lib/js/belt_Array.js");

function getOptionLabel(x) {
  return x.label;
}

function getOptionValue(x) {
  return x.value.toString();
}

function makeLabel(n, options) {
  var match = options.filter(function (x) {
        return x.value === n;
      });
  if (match.length !== 1) {
    return n.toString();
  } else {
    return match[0].label;
  }
}

var $$Option = {
  getOptionLabel: getOptionLabel,
  getOptionValue: getOptionValue,
  makeLabel: makeLabel
};

var forSaleOptions = [
  {
    value: 100000,
    label: "100K"
  },
  {
    value: 125000,
    label: "125K"
  },
  {
    value: 150000,
    label: "150K"
  },
  {
    value: 175000,
    label: "175K"
  },
  {
    value: 200000,
    label: "200K"
  },
  {
    value: 225000,
    label: "225K"
  },
  {
    value: 250000,
    label: "250K"
  },
  {
    value: 275000,
    label: "275K"
  },
  {
    value: 300000,
    label: "300K"
  },
  {
    value: 325000,
    label: "325K"
  },
  {
    value: 350000,
    label: "350K"
  },
  {
    value: 375000,
    label: "375K"
  },
  {
    value: 400000,
    label: "400K"
  },
  {
    value: 425000,
    label: "425K"
  },
  {
    value: 450000,
    label: "450K"
  },
  {
    value: 475000,
    label: "475K"
  },
  {
    value: 500000,
    label: "500K"
  },
  {
    value: 550000,
    label: "550K"
  },
  {
    value: 600000,
    label: "600K"
  },
  {
    value: 650000,
    label: "650K"
  },
  {
    value: 700000,
    label: "700K"
  },
  {
    value: 750000,
    label: "750K"
  },
  {
    value: 800000,
    label: "800K"
  },
  {
    value: 850000,
    label: "850K"
  },
  {
    value: 900000,
    label: "900K"
  },
  {
    value: 950000,
    label: "950K"
  },
  {
    value: 1000000,
    label: "1M"
  },
  {
    value: 1250000,
    label: "1.25M"
  },
  {
    value: 1500000,
    label: "1.5M"
  },
  {
    value: 1750000,
    label: "1.75M"
  },
  {
    value: 2000000,
    label: "2M"
  },
  {
    value: 2250000,
    label: "2.25M"
  },
  {
    value: 2500000,
    label: "2.5M"
  },
  {
    value: 2750000,
    label: "2.75M"
  },
  {
    value: 3000000,
    label: "3M"
  },
  {
    value: 3250000,
    label: "3.25M"
  },
  {
    value: 3500000,
    label: "3.5M"
  },
  {
    value: 3750000,
    label: "3.75M"
  },
  {
    value: 4000000,
    label: "4M"
  },
  {
    value: 4250000,
    label: "4.25M"
  },
  {
    value: 4500000,
    label: "4.5M"
  },
  {
    value: 4750000,
    label: "4.75M"
  },
  {
    value: 5000000,
    label: "5M"
  },
  {
    value: 6000000,
    label: "6M"
  },
  {
    value: 7000000,
    label: "7M"
  },
  {
    value: 8000000,
    label: "8M"
  },
  {
    value: 9000000,
    label: "9M"
  },
  {
    value: 10000000,
    label: "10M"
  },
  {
    value: 12500000,
    label: "12.5M"
  },
  {
    value: 15000000,
    label: "15M"
  },
  {
    value: 17500000,
    label: "17.5M"
  },
  {
    value: 20000000,
    label: "20M"
  },
  {
    value: 22500000,
    label: "22.5M"
  },
  {
    value: 25000000,
    label: "25M"
  }
];

var rentalOptions = [
  {
    value: 800,
    label: "800"
  },
  {
    value: 850,
    label: "850"
  },
  {
    value: 900,
    label: "900"
  },
  {
    value: 1000,
    label: "1,000"
  },
  {
    value: 1250,
    label: "1,250"
  },
  {
    value: 1500,
    label: "1,500"
  },
  {
    value: 1750,
    label: "1,750"
  },
  {
    value: 2000,
    label: "2,000"
  },
  {
    value: 2250,
    label: "2,250"
  },
  {
    value: 2500,
    label: "2,500"
  },
  {
    value: 2750,
    label: "2,750"
  },
  {
    value: 3000,
    label: "3,000"
  },
  {
    value: 3250,
    label: "3,250"
  },
  {
    value: 3500,
    label: "3,500"
  },
  {
    value: 3750,
    label: "3,750"
  },
  {
    value: 4000,
    label: "4,000"
  },
  {
    value: 4250,
    label: "4,250"
  },
  {
    value: 4500,
    label: "4,500"
  },
  {
    value: 4750,
    label: "4,750"
  },
  {
    value: 5000,
    label: "5,000"
  },
  {
    value: 5500,
    label: "5,500"
  },
  {
    value: 6000,
    label: "6,000"
  },
  {
    value: 6500,
    label: "6,500"
  },
  {
    value: 7000,
    label: "7,000"
  },
  {
    value: 7500,
    label: "7,500"
  },
  {
    value: 8000,
    label: "8,000"
  },
  {
    value: 8500,
    label: "8,500"
  },
  {
    value: 9000,
    label: "9,000"
  },
  {
    value: 9500,
    label: "9,500"
  },
  {
    value: 10000,
    label: "10,000"
  },
  {
    value: 11000,
    label: "11,000"
  },
  {
    value: 12000,
    label: "12,000"
  },
  {
    value: 13000,
    label: "13,000"
  },
  {
    value: 14000,
    label: "14,000"
  },
  {
    value: 15000,
    label: "15,000"
  },
  {
    value: 17500,
    label: "17,500"
  },
  {
    value: 20000,
    label: "20,000"
  },
  {
    value: 22500,
    label: "22,500"
  },
  {
    value: 25000,
    label: "25,000"
  },
  {
    value: 27500,
    label: "27,500"
  },
  {
    value: 30000,
    label: "30,000"
  },
  {
    value: 32500,
    label: "32,500"
  },
  {
    value: 35000,
    label: "35,000"
  },
  {
    value: 37500,
    label: "37,500"
  },
  {
    value: 40000,
    label: "40,000"
  },
  {
    value: 42500,
    label: "42,500"
  },
  {
    value: 45000,
    label: "45,000"
  },
  {
    value: 47500,
    label: "47,500"
  },
  {
    value: 50000,
    label: "50,000"
  },
  {
    value: 60000,
    label: "60,000"
  },
  {
    value: 70000,
    label: "70,000"
  },
  {
    value: 80000,
    label: "80,000"
  },
  {
    value: 90000,
    label: "90,000"
  },
  {
    value: 100000,
    label: "100K"
  },
  {
    value: 150000,
    label: "150K"
  },
  {
    value: 200000,
    label: "200K"
  }
];

var PriceFilters = {
  forSaleOptions: forSaleOptions,
  rentalOptions: rentalOptions
};

var options = Belt_Array.range(1, 10).map(function (n) {
      return {
              value: n,
              label: n.toString()
            };
    });

var BedsFilters = {
  options: options
};

exports.$$Option = $$Option;
exports.PriceFilters = PriceFilters;
exports.BedsFilters = BedsFilters;
/* options Not a pure module */
